const { connect } = require('react-redux');
const stageClearComponent = require('../component/stageClearComponent').default;
const { actions } = require('../../../../reducers').default;
const { modalType } = require('../../../../define/screenType').default;
// ======================

const mapStateToProps = (state) => {
    const { screenState, playerState, gameState, appState } = state;
    return {
        isModalOpen: screenState.modal === modalType.MODAL_STAGE_CLAER,
        soundEnable: appState.soundEnable,
        playerState,
        gameState
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleTitleClick: () => {
            dispatch(actions.modalDisable());
            dispatch(actions.modalEnable(modalType.MODAL_RESULT));
        },
        handleNextClick: (nextStage, isScenario) => {
            dispatch(actions.modalDisable());
            dispatch(actions.initStage(nextStage));
            if (isScenario) {
                dispatch(actions.modalEnable(modalType.MODAL_SCENARIO));
            } else {
                dispatch(actions.modalEnable(modalType.MODAL_STAGE_START));
            }
        }
    };
};

export const StageClearContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(stageClearComponent);